import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type Nem12State = {
  responseBatchId: string | null;
};

const initialState: Nem12State = {
  responseBatchId: null,
};

const nem12Slice = createSlice({
  name: "nem12",
  initialState,
  reducers: {
    setResponseBatchId(state, action: PayloadAction<string | null>) {
      state.responseBatchId = action.payload;
    },
    clearResponseBatchId(state) {
      state.responseBatchId = null;
    },
  },
});

export const { setResponseBatchId, clearResponseBatchId } = nem12Slice.actions;
export default nem12Slice.reducer;
